
import React, {
    useEffect
} from 'react';

import {
    useCurationConfigState,
    useCurationConfigValue
} from '../../../../hooks/widgetConfiguration.js';

import {
    RIQPopover,
    RIQInfoPopover
} from '../../../../components/RIQPopover.jsx';
import RIQPillInput from '../../../../components/RIQPillInput.jsx';
import QueryValidationError from '../QueryValidationError.jsx';
import FilterSuggestions from './FilterSuggestions.jsx';

import {
    useVerifySearch
} from '../../hooks/useVerifySearch.js';

import {
    listeningDefinitions
} from '../enums/listeningDefinitions.jsx';

import DelayedWidgetLoad from './DelayedWidgetLoad.jsx';

const {
    excludeDomainsTitle,
    excludeDomainsDescription,
    excludeDomainsFilterLabel
} = listeningDefinitions['saved-search'];


export default function DomainsFilters() {

    const [excludedDomain, setExcludedDomain] = useCurationConfigState('excludeDomain');
    const source = useCurationConfigValue('source');

    const isOnlyTwitter = _.isEqual(source, ['Twitter']);

    useEffect(() => {
        if (isOnlyTwitter && !_.isEmpty(excludedDomain)) {
            setExcludedDomain(null);
        }
    }, [isOnlyTwitter, excludedDomain, setExcludedDomain]);

    const {orderedErrors} = useVerifySearch(false, {
        excludeDomain: excludedDomain
    });

    const excludeDomainError = !_.isEmpty(excludedDomain) ? _.findLast(orderedErrors, {
        group: 'excludeDomain'
    }) : null;


    const domainFilterSection = (
        <div
            className={`tlw-mx-8 tlw-mb-8 tlw-items-start ${isOnlyTwitter ? 'tlw-pointer-events-none tlw-opacity-50' : ''}`}
        >
            <div
                className='tlw-mb-2.5 tlw-text-gray-900'
            >
                {excludeDomainsTitle}

                <RIQInfoPopover
                    title={excludeDomainsTitle}
                    description={excludeDomainsDescription}
                />
            </div>

            <RIQPillInput
                className='tlw-w-full'
                pills={excludedDomain || []}
                setPills={setExcludedDomain}
                focusedPillIdx={excludeDomainError?.idx}
                inputUniqueId='excludeDomainInput'
                multiline={true}
                operator={false}
            />
            <QueryValidationError
                searchTermsError={excludeDomainError}
            />
        </div>
    );

    return (
        <div>
            {isOnlyTwitter &&
            <RIQPopover
                triggerNode={domainFilterSection}
                placement='top'
                className='tlw-w-full'
                additionalHookProps={{
                    delayShow: RIQPopover.StandardDelayMS
                }}
            >
                <div
                    className='tlw-p-5'
                >
                    Domain filters are not available when Twitter is selected as the only source.
                </div>
            </RIQPopover>
            }

            {!isOnlyTwitter &&
            <>
                {domainFilterSection}

                <DelayedWidgetLoad
                    instanceId={`filter-suggestions-domain`}
                    showLoadingView={true}
                >
                    <FilterSuggestions
                        exclusionsConfigKey='excludeDomain'
                        dimension='domain'
                        dimensionName='domain'
                        label={excludeDomainsFilterLabel}
                        resultToValue={result => result.count[0]}
                        measuresToRequest={[{
                            field: 'count',
                            returns: 'dimensionValue(domain)'
                        }]}
                    />
                </DelayedWidgetLoad>

            </>
            }

        </div>
    );
}
